import type { ProspectListViewSettings } from "../../api/client.ts";

export function settingsEqual(
  a: ProspectListViewSettings,
  b: ProspectListViewSettings,
): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
